var render = function render(){var _vm=this,_c=_vm._self._c;return (!!_vm.alerts)?_c('v-alert',{staticClass:"mb-4",attrs:{"text":"","border":"left","type":_vm.alerts.type || 'info'}},[_c('strong',[_vm._v("Preencha os dados para completar o cadastro:")]),_c('ul',_vm._l((_vm.alerts.alerts),function(alert,i){return _c('li',{key:i},[_vm._v(_vm._s(alert.message))])}),0)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }